import { createContext } from 'react';

import { type SSEHandler, type SSEMessageTypes } from '../types';

export type SseEngineContextValue = {
  addSseHandler: (key: SSEMessageTypes, handler: SSEHandler) => void;
  removeSseHandler: (key: SSEMessageTypes, handler: SSEHandler) => void;
  addInitialHandler: (handler: () => void) => void;
  removeInitialHandler: (handler: () => void) => void;
};

const noop = () => undefined;

export const SseEngineContext = createContext<SseEngineContextValue>({
  addSseHandler: noop,
  removeSseHandler: noop,
  addInitialHandler: noop,
  removeInitialHandler: noop,
});
